import {gql} from '@apollo/client';
import React from 'react';

import {useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {StorableSchemaSubdependencyInputQuery} from './__generated/StorableSchemaSubdependencyInputQuery';
import BaseSchemaSubdependencyInput from './BaseSchemaSubdependencyInput';
import {ChildDependencyTypes} from './ChildDependencyTypes';

export const STORABLE_SCHEMA_SUBDEPENDENCY_INPUT_QUERY = gql`
  query StorableSchemaSubdependencyInputQuery($id: StrictString!)
  @skipAudit
  @engComponent(name: BENCHLING_APPS) {
    storableSchema(id: $id) {
      ... on StorableSchemaInterface {
        ...StorableSchemaGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('StorableSchema').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function StorableSchemaSubdependencyInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<StorableSchemaSubdependencyInputQuery>(
    STORABLE_SCHEMA_SUBDEPENDENCY_INPUT_QUERY,
    {
      skip: parentDependencySelectedId == null,
      variables: {id: parentDependencySelectedId},
    }
  );

  return (
    <BaseSchemaSubdependencyInput<StorableSchemaSubdependencyInputQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => result.data.storableSchema}
    />
  );
}
